export function SavingsPill({ savingsLabel }: { savingsLabel: string }) {
  return (
    <div className="hidden xs:flex bg-bud-40 rounded-full px-2 py-1 w-min items-center justify-center">
      <span className="font-mori text-acai text-lg font-semibold whitespace-nowrap">
        {savingsLabel}
      </span>
    </div>
  )
}
